import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Press = lazy(() => import("@/pages/info/Press"));

export const Route = createFileRoute("/press")({
  head: () => seoHead("/press", { description: "Här hittar du presskontakt, logotyper, bildbank, varumärkesriktlinjer och faktablad. Vi medverkar regelbundet i media kring elpris, energifrågor och hushållsekonomi." }),
  component: () => <Press />,
});
